var $ = jQuery.noConflict ();


/* For element with class .height_100 set min-height 100% in pixels - engine.js */
function height_100(){
    var screenheight = jQuery (window).height ();
    var docheight = jQuery (document).height ();
    jQuery ('.height_100').css ("min-height", screenheight + "px");
}

/* Make #content padding top whene use fixed menu - engine.js */
function fixedTopForHeader(){
    var getheight = jQuery ('header#header').outerHeight ();

    if ($ (window).width () >= 992) {
        jQuery ('#content').css ('padding-top', getheight);
    } else {
        jQuery ('#content').css ('padding-top', '0');
    }
}

/*
*   DISPLAY SCREEN SIZE ON RIGHT BOTTOM
* *
 */

function screenSize(){
    $ (window).on ('resize', function (){
        var width = $ ('body').width ();
        $ ('.breakpoint-view .size').html (width)

    });
}

function showGridLines(){
    $ ('.breakpoint-view').on ('click', function (){
        $ ('.grid-view').toggleClass ('active');
        $ ('.breakpoint-view .switcher').toggleClass ('active');
    })
}


/*
*   BOOTSTRAP
* */

/* Bootstrap - on hover show (slide) submenu - engine.js */
function toggleNavbarMethod(){
    jQuery (function ($){
        if ($ (window).width () > 769) { // ograniczenie dla mobile menu
            $ ('.dropdown').on ('hover', function (){
                $ (this).find ('.dropdown-menu').first ().stop (true, true).delay (250).slideDown ();

            }, function (){
                $ (this).find ('.dropdown-menu').first ().stop (true, true).delay (100).slideUp ();
            });
            $ ('.dropdown > a').on ('click tap', function (){
                //location.href = this.href;
            });
        }
    });
}

/* Bootstrap -  set same height for all .col* in .row-eq-height - engine.js */
function rowEQheight(){
    jQuery ('.row-eq-height').each (function (){
        jQuery (this).children ("[class*=' col']").height ('auto');
        if ($ (window).width () > 992) {
            var seth = 0;
            jQuery (this).children ("[class*=' col']").each (function (){
                newh = jQuery (this).height ();
                if (newh > seth) {
                    seth = newh;
                }
            });
            jQuery (this).children ("[class*=' col']").height (seth);
        } else {
            jQuery (this).children ("[class*=' col']").height ('auto');
        }
    });
}

/* Bootstrap - full width element .full_width_element when use container for all page */
function fullWidthElement(){
    var wrapper = jQuery ('body');
    jQuery ('.full_width_element').each (function (){
        jQuery (this).css ({
            "margin-left": 0,
            "margin-right": 0,
            "padding-left": 0,
            "padding-right": 0
        })
        var left = jQuery (this).offset ().left;
        var right = jQuery (this).offset ().right;
        jQuery (this).css ({
            "margin-left": -left,
            "margin-right": -left
        })
        if (jQuery ('.slick-slider-page').length) {
            jQuery ('.slick-slider-page').slick ('reinit');
        }
    });

}

/* Bootstrap - scroll to colapsed element in acordeon */
function scrollToColapsedElement(){
    jQuery (".panel-default").on ('shown.bs.collapse', function (){
        jQuery ('html,body').animate ({
                scrollTop: $ (this).children ('.panel-collapse').offset ().top - 200
            },
            'slow');
    });
}


function is_touch_device(){
    return 'ontouchstart' in window // works on most browsers
        || 'onmsgesturechange' in window; // works on ie10
}
